import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { CHEAT_SHEET_SHORTCUT, ShortcutHint } from '@/components/shortcuts';

/**
 * The sign-in screen's key hint (bos-seller#47: hints are always visible on
 * the sign-in and sale screens): `F1` opens the cheat sheet, which lists the
 * physical PIN keys. It sits in the screen's frame, below whichever step is
 * showing, so the PIN pad itself stays free of hints (bos-seller#52). Laid out
 * like a cheat-sheet row, and read like one: the action's name, then its key.
 */
export const SellerLoginShortcutsHint: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <div className="flex items-center gap-2">
            <Typography color="muted" type="body-xs">
                {t(CHEAT_SHEET_SHORTCUT.labelKey)}
            </Typography>
            <ShortcutHint placement="list" shortcut={CHEAT_SHEET_SHORTCUT} />
        </div>
    );
};
